import { CancelToken } from "axios";
import { api } from "utils/http-common";

class DashboardService{
  countCompanies(cancelToken:CancelToken){
    return api.get<number>("dashboard/count-companies",{params:{},cancelToken:cancelToken});
  }
  totalBudget(cancelToken:CancelToken){
    return api.get<number>("dashboard/total-budget",{params:{},cancelToken:cancelToken});
  }
  totalAction(cancelToken:CancelToken){
    return api.get<number>("dashboard/total-action",{params:{},cancelToken:cancelToken});
  }
  budgetByCompany(cancelToken:CancelToken){
    return api.get<{label:string,value:number}[]>("dashboard/budget-by-company",{params:{},cancelToken:cancelToken});
  }
  budgetByCategory(cancelToken:CancelToken){
    return api.get<{label:string,value:number}[]>("dashboard/budget-by-category",{params:{},cancelToken:cancelToken});
  }
}

const dashboardService = new DashboardService();
export default dashboardService;